import React from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

export default function AuthLayout({ children }) {
    return (
        <Layout style={{ minHeight: '100vh', height: '100vh', background: 'var(--dark-bg-start)' }}>
            <Content style={{ margin: 0, padding: 0, minHeight: '100vh', height: '100%' }}>
                {children}
            </Content>
        </Layout>
    );
}
